import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BanUserApiService } from '../backend-api/ban-user-api.service';

/**
 * Thin real-backend wrapper around `BanUserService` (`@curbnturf/rating`) for
 * the host-facing "don't host this guest again" action. Mirrors the
 * server-side split between `RatingModule`/`GuestBanModule` — the admin-only
 * list/unban methods stay on `BanUserService` itself (used by curbnturf-admin,
 * a different app/design system), this wrapper only exposes what a host needs.
 */
@Injectable({ providedIn: 'root' })
export class GuestBanService {
  private banUserService = inject(BanUserApiService);

  async banGuest(guestUserId: number, reservationId: number): Promise<void> {
    await firstValueFrom(this.banUserService.banGuest({ id: guestUserId }, { id: reservationId }));
  }
}
